import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { CommonResponse } from "@gtpl/shared-models/production-management";
import { GlobalPriceChartService } from "./global-price-chart.service";
import { GlobalPriceChartRequest, GlobalPriceChartResponseModel } from "@gtpl/shared-models/masters";

@ApiTags('global-price-chart')
@Controller('global-price-chart')
export class GlobalPriceChartController {
    constructor(
        private globalPriceChartService: GlobalPriceChartService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }
    /**
     * creates or updates a value of Exchange Rates
     * @param EndCustomersDto Exchange Rates DTO
     * @returns CommonResponse
     */
    @Post('/getAllPriceCharts')
    async getAllPriceCharts(): Promise<GlobalPriceChartResponseModel> {
        try {
            return await this.globalPriceChartService.getAllPriceCharts();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(GlobalPriceChartResponseModel, error)
        }
    }

    @Post('/updatePriceCharts')
    async updatePriceCharts(@Body() req: GlobalPriceChartRequest): Promise<GlobalPriceChartResponseModel> {
        try {
            return await this.globalPriceChartService.updatePriceCharts(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(GlobalPriceChartResponseModel, error)
        }
    }
    @Post('/getAntiDumpingPrice')
    async getAntiDumpingPrice(): Promise<CommonResponse> {
        try {
            return await this.globalPriceChartService.getAntiDumpingPrice();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }
}